import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import IndustryWeWorkData from '../../db.json';

const IndustryWeWork = () => {
	const itemVariants = {
		hidden: { opacity: 0, scale: 0.8, y: 50 },
		visible: {
			opacity: 1,
			scale: 1,
			y: 0,
			transition: { duration: 0.5 },
		},
	};
	
	const data = IndustryWeWorkData.idustryWeWork;
	// console.log(data);

	return (
		<Container style={{ marginTop: 100 }}>
			<Typography
				variant='h4'
				align='center'
				sx={{ fontWeight: 'bold', marginBottom: '40px' }}>
				Industry We Work With
			</Typography>
			<Grid container spacing={2} style={{ marginTop: 50 }}>
				{data.map((i, index) => {
					return (
						<Grid item xs={6} sm={6} md={3} key={index}>
							<motion.div
								variants={itemVariants}
								initial='hidden'
								whileInView='visible' 
								viewport={{ once: true, amount: 0.2 }}
								style={{
									// display: 'flex',
									justifyContent: 'center',
									boxShadow: '0 22px 50px 0 #0000001a',
									background: 'white',
									borderRadius: 5,
									padding: 20,
								}}>
								<Box display={'flex'} justifyContent={'center'}>
									<img
										src={i.image}
										alt='Industry Logo'
										style={{
											height: '80px',
											transition: 'transform 0.3s ease',
											'&:hover': {
												transform: 'scale(1.1)', 
											},
										}}
									/>
								</Box>
								<p
									style={{
										textAlign: 'center',
										fontSize: 20,
										fontWeight: 'bold',
									}}>
									{i.title}
								</p>
							</motion.div>
						</Grid>
					);
				})}
			</Grid>
		</Container>
	);
};

export default IndustryWeWork;
